module["exports"] = [
  "ჯგუფი",
  "და კომპანია",
  "სტუდია",
  "გრუპი"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/ge/company/suffix.js
// module id = 1953
// module chunks = 0